export default __webpack_public_path__ + "static/media/SAS Chat Tone 3.e33e7675.wav";